"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var AdvertiseWithUsComponent = /** @class */ (function () {
    function AdvertiseWithUsComponent() {
        window.location.href = "https://wickedlist.com/b/contact-us/";
    }
    AdvertiseWithUsComponent.prototype.ngOnInit = function () {
    };
    return AdvertiseWithUsComponent;
}());
exports.AdvertiseWithUsComponent = AdvertiseWithUsComponent;
